import Store from '@/store/index'
// Store has not loaded on intial load so need to add if statement before using it

import {
  localStorageConfigsName
} from '@/utils/types'

const setInitialStatesFromStorage = (configs: any) => {
  const autoProcessProvider = (configs && configs.autoProcessProvider) || 'trustly'
  const cashierType = (configs && configs.demoThemesOptions && configs.demoThemesOptions.dynamicCashierType) || ''
  Store && Store.commit('setAutoProcessProvider', autoProcessProvider)
  Store && Store.commit('setCashierType', cashierType)
}

const checkForSavedConfigs = (): null | object => {
  const __CASHIER_DEMO_CONFIGS__: string | null = localStorage.getItem(localStorageConfigsName)
  const configs = __CASHIER_DEMO_CONFIGS__ && JSON.parse(__CASHIER_DEMO_CONFIGS__)
  setInitialStatesFromStorage(configs)
  return configs && {
    environment: configs.environment,
    merchantId: configs.merchantId,
    sessionId: configs.sessionId,
    userId: configs.userId
  }
}

const bankingConfigs = () => ({
  amountFirst: true,
  tabs: false,
  showAmountLimits: true,
  listType: 'grid',
  showFooter: false,
  showFee: false,
  ...checkForSavedConfigs() && checkForSavedConfigs()
})

export default bankingConfigs
